'use strict';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import { createForm } from 'rc-form';
import { GenericModal, GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';
import Title from './Title.jsx';
import CheckHomeBanking from './CheckHomeBanking.jsx';
import RadioButtonRubros from './RadioButtonRubros.jsx';
import RadioButtonCartera from './RadioButtonCartera.jsx';
import RadioButtonBonificacionRenovacion from './RadioButtonBonificacionRenovacion.jsx';
import CheckAllow from './CheckAllow.jsx';
import InputBonus from './InputBonus.jsx';
import InputDescripcion from './InputDescripcion.jsx';
import InputDates from './InputDates.jsx';
import InputDestinatarioReporte from './InputDestinatarioReporte.jsx';
import InputLimiteCompra from './InputLimiteCompra.jsx';
import ButtonAdd from './ButtonAdd.jsx';
import CheckUpdateValue from './CheckUpdateValue.jsx';
import LabelDatosEmpresa from './LabelDatosEmpresa.jsx';
import LabelDomicilios from './LabelDomicilios.jsx';
import Breadcrumb from '../../NuevaSolicitudAdministradora/components/MarcaBreadcrumb.jsx'
import ClienteTitle from '../../NuevaSolicitudAdministradora/components/ClienteTitle.jsx';

const GenericAlertWrapper = ({ showError }) => {

    if (!showError)
        return null;

    return <GenericAlert message="Por favor complete todos los campos" type="danger" />;
}

class Empresa extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.getScreenData(id, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {

        const { data, routeToNuevaEmpresa, routeToCancel, validateAddEnterprise, form } = this.props;

        if (data != undefined) {
            if (data.dataFetched == false) {
                return <div className="loading"> Loading &#8230;</div>;
            }

            const {
                edicion,
                altaOk,
                tarjetas_empresas,
                redirectToNuevaSolicitudEmpresa,
                showError
            } = data;

            let titulo = edicion ? "Editar Empresa" : "Nueva Empresa";

            if (altaOk)
                routeToNuevaEmpresa(tarjetas_empresas);

            if (redirectToNuevaSolicitudEmpresa) {
                const cancelRoute = ProcessManager.GetNextStep("Empresa", "ROUTE_TO_EMPRESA");
                return <Redirect to={cancelRoute} push />;
            }

            return (
                <form id="bloqueoUsuario">
                    
                    <ClienteTitle
                                cliente={this.props.tarjetas.clienteResultadoBusqueda}
                                empresas={null}
                                novedadesempresas={null}
                                esmodificacion={false}
                                />
                    <Breadcrumb
                        menu={this.breadcrumbGenerator(1,this.props.tarjetas.tipoEmpresa.Descripcion)}
                    />
                    <div className="container-fluid container-fluid-bordered">
                        <Title titulo={titulo} />
                        <ButtonAdd
                            data={data}
                            key={"BUTTON_HEADER"}
                            validateAddEnterprise={validateAddEnterprise}
                            routeToCancel={routeToCancel}
                            form={form}
                            edicion={edicion}
                        />
                        <GenericAlertWrapper showError={showError} />
                        <LabelDatosEmpresa data={data} />
                        <InputDescripcion
                            data={data}
                            changeInput={this.props.changeInput}
                            changecheckEsConfidencial={this.props.changecheckEsConfidencial}
                            form={this.props.form} />
                        <LabelDomicilios
                            data={data}
                            changeRadio={this.props.changeRadio}
                            changeInput={this.props.changeInput}
                            form={this.props.form} />
                        <InputDestinatarioReporte
                            data={data}
                            changeInput={this.props.changeInput}
                            form={this.props.form} />
                        <CheckHomeBanking
                            data={data}
                            changeCheck={this.props.changeCheck} />
                        <InputLimiteCompra
                            data={data}
                            tarjetas={this.props.tarjetas}
                            changeInput={this.props.changeInput}
                            form={this.props.form} />
                        <RadioButtonCartera
                            data={data}
                            changeRadio={this.props.changeRadio}
                        />
                        <RadioButtonRubros
                            data={data}
                            removeRubro={this.props.removeRubro}
                            filtroRubro={this.props.filtroRubro}
                            selectRubro={this.props.selectRubro}
                        />
                        <CheckAllow
                            data={this.props.data}
                            tarjetas={this.props.tarjetas}
                            changeCheck={this.props.changeCheck} />
                        <InputBonus
                            data={data}
                            changeInput={this.props.changeInput}
                            form={this.props.form}
                        />
                        <RadioButtonBonificacionRenovacion
                            data={data}
                            changeRadio={this.props.changeRadio}
                        />
                        <CheckUpdateValue
                            data={data}
                            changeCheck={this.props.changeCheck}
                            changeDate={this.props.changeDate}
                            changeDataError={this.props.changeDataError} />
                        <InputDates
                            data={this.props.data}
                            tarjetas={this.props.tarjetas}
                            changeDate={this.props.changeDate}
                            changeInput={this.props.changeInput}
                            form={this.props.form}
                        />
                        <GenericAlertWrapper showError={showError} />
                        <ButtonAdd
                            data={data}
                            key={"BUTTON_FOOTER"}
                            validateAddEnterprise={validateAddEnterprise}
                            routeToCancel={routeToCancel}
                            form={form}
                            edicion={edicion}
                        />
                        <GenericModal
                            type={"DISCARD_CHANGES_CANCEL"}
                            className="modal fade-out"
                            onClick={this.cancelRequest}
                            id={"discardChangesModal"}
                            header={"Descartar cambios"}
                            body={"Usted tiene cambios sin guardar ¿Quiere descartarlos y volver a la pantalla anterior"}
                        />
                    </div>
                </form>
            );
        }
        else
            return null;
    }

    breadcrumbGenerator(idAdm,tipoDeCuenta) {
        let nuevaSolicitudMap = [];

        nuevaSolicitudMap.push({ descripcion: idAdm ==1 ? "VISA": "CABAL", ruta: "", activo: false, normal: true, anterior: true });
        nuevaSolicitudMap.push({ descripcion: tipoDeCuenta, ruta: "", activo: false, normal: true, anterior: true });
        nuevaSolicitudMap.push({ descripcion: "Empresa", ruta: "", activo: true, normal: false, anterior: false });
        nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true, anterior: false });
        nuevaSolicitudMap.push({ descripcion: "Extensiones", ruta: "", activo: false, normal: true, anterior: false });

        return nuevaSolicitudMap;
    }
};

export default createForm()(Empresa);